import React, { forwardRef } from 'react';

import type { HTMLAttributes } from 'types';
import { cn } from 'utils/classNames';

interface Props extends HTMLAttributes<HTMLDivElement> {
	/** Show a small indicator slightly below the element on focus. */
	showIndicator?: boolean;
}

/** Target for programmatic focusing that doesn't show a standard outline. */
const FocusTarget = forwardRef<HTMLDivElement, Props>(
	({ className, showIndicator = true, tabIndex = -1, ...attrs }, ref) => (
		<div
			ref={ref}
			className={cn(
				'focus-outline-none outline-0',
				showIndicator && [
					'relative',
					'after:absolute',
					'after:top-1',
					'after:left-1/2',
					'after:-translate-x-1/2',
					'after:w-24',
					'after:max-w-full',
					'after:h-0.5',
					'after:rounded-full',
					'focus-visible:after:bg-current',
					'forced-colors:focus-visible:after:bg-[CanvasText]',
				],
				className,
			)}
			tabIndex={tabIndex}
			{...attrs}
		/>
	),
);
FocusTarget.displayName = 'FocusTarget';

export default FocusTarget;
